// --- Dependencies -------------------------------------------------------------------------------
import { create } from "zustand";
import { persist } from "zustand/middleware";
// --- Our Modules --------------------------------------------------------------------------------
import type { TyAdmin } from "@/types";
// --- Logic --------------------------------------------------------------------------------------
type TyAuthStore = {
    token: string | null;
    admin: TyAdmin | null;
    setToken: (token: string) => void;
    setAdmin: (admin: TyAdmin) => void;
    logout: () => void;
};

/**
 * One identity per device, unlike `clients-web`. There, offices share a machine and a shift change is
 * a switch rather than a sign-in; Lozicore's own team is a handful of people on their own laptops, and
 * a parked second session on an admin account is a liability rather than a convenience.
 *
 * The token is long-lived and revocable from `admin.tokens` on the backend, so signing out here only
 * has to forget it locally — there is no session to tear down.
 */
const useAuth = create<TyAuthStore>()(
    persist(
        (set) => ({
            token: null,
            admin: null,

            setToken: (token) => set({ token }),
            setAdmin: (admin) => set({ admin }),

            logout: () => set({ token: null, admin: null }),
        }),
        { name: "auth" }
    )
);

export default useAuth;
